import { h } from 'vue';
import { VIcon } from 'vuetify/components';

const componentNames = [
  'VAutocomplete',
  'VBadge',
  'VBtnToggle',
  'VCheckbox',
  'VCheckboxBtn',
  'VChip',
  'VCombobox',
  'VDatePicker',
  'VField',
  'VInput',
  'VProgressCircular',
  'VRadio',
  'VRadioGroup',
  'VRating',
  'VSlider',
  'VSelect',
  'VSwitch',
  'VTabs',
  'VTextarea',
  'VTextField'
];
const menuItems = ['VSelect', 'VCombobox', 'VAutocomplete', 'VDatePicker'];
const defaultProperties = {
  VAutocomplete: {
    VChip: {
      variant: 'elevated'
    },
    clearIcon: 'close',
    iconColor: 'disabled-text',
    menuIcon: 'keyboard_arrow_down',
    persistentClear: true
  },
  VBtn: {
    flat: true
  },
  VBtnToggle: { density: 'compact' },
  VCard: {
    flat: true
  },
  VCardActions: {
    VBtn: { variant: 'elevated' }
  },
  VChip: {
    closeIcon: 'close'
  },
  VCombobox: {
    VChip: {
      variant: 'elevated'
    },
    clearIcon: 'close',
    iconColor: 'disabled-text',
    menuIcon: 'keyboard_arrow_down',
    persistentClear: true
  },
  // VDialog: { zIndex: 2147483646 }, // highest z-index for dialogs
  VMenu: {
    scrollStrategy: 'none',
    zIndex: 6
    // target: 'parent'
  },
  VSelect: {
    clearIcon: 'close',
    iconColor: 'disabled-text',
    menuIcon: 'keyboard_arrow_down',
    persistentClear: true
  },
  VSwitch: {
    inset: true
  },
  VRadioGroup: {
    trueIcon: h(VIcon, { size: 'small', icon: '$radioOn' }),
    falseIcon: h(VIcon, { size: 'small', icon: '$radioOff' })
  },
  VCheckbox: {
    trueIcon: h(VIcon, { size: 'small', icon: '$checkboxOn' }),
    falseIcon: h(VIcon, { size: 'small', icon: '$checkboxOff' })
  },
  VCheckboxBtn: {
    trueIcon: h(VIcon, { size: 'small', icon: '$checkboxOn' }),
    falseIcon: h(VIcon, { size: 'small', icon: '$checkboxOff' })
  },
  VTabs: { sliderColor: 'tab-color', selectedClass: 'font-weight-bold' },
  VTextField: {
    clearIcon: 'close',
    persistentClear: true
  },
  VTextarea: {
    clearIcon: 'close',
    iconColor: 'disabled-text',
    persistentClear: true
  }
};

// Set color to primary for all components and add menuProps for menu items.
export const vuetifyDefaults = componentNames.reduce((themeConfig, name) => {
  themeConfig[name] = { ...themeConfig[name], color: 'primary' };
  if (menuItems.includes(name)) {
    themeConfig[name]['menuProps'] = { scrollStrategy: 'none', zIndex: 6, target: 'parent' };
  }
  return themeConfig;
}, defaultProperties);
